import { render, staticRenderFns } from "./mp_media_activity.vue?vue&type=template&id=8edb941c&"
import script from "./mp_media_activity.vue?vue&type=script&lang=js&"
export * from "./mp_media_activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports